import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { GetBankAccountDataResponse } from '@/modules/bank/type'
import BankAccountTable from '../BankAccountTable'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import useMutationSyncBank from '@/modules/bank/api/hooks/useMutationSyncBank'

interface BankAccountListingProps {
	data?: GetBankAccountDataResponse[]
	total?: number
	isLoading?: boolean
}

export default function BankAccountListing({
	data,
	total,
	isLoading,
}: BankAccountListingProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_BANK_ACCOUNT,
	)
	const { mutate: mutateSyncBank } = useMutationSyncBank()
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`รายการบัญชีธนาคาร`} description="รายการบัญชีธนาคาร" />
				<div className="flex items-center gap-2">
					{hasWritePermission && (
						<Button
							variant="outline"
							onClick={() => {
								mutateSyncBank()
							}}
						>
							sync ธนาคาร
						</Button>
					)}
					{hasWritePermission && (
						<Button asChild variant="default">
							<Link to="/operator/bank-account/create-bank-account">
								เพิ่มบัญชีธนาคาร
							</Link>
						</Button>
					)}
				</div>
			</div>
			<Separator />
			<BankAccountTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
